import React from "react";

export default function IconCaromDown() {
  return (
    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.35321 3.73913L0.949621 1.47826C0.656877 1.2029 0.591549 0.887826 0.753637 0.533043C0.915108 0.177681 1.20385 0 1.61985 0H6.3808C6.7968 0 7.08554 0.177681 7.24701 0.533043C7.4091 0.887826 7.34377 1.2029 7.05103 1.47826L4.64744 3.73913C4.555 3.82609 4.45485 3.8913 4.347 3.93478C4.23914 3.97826 4.12359 4 4.00033 4C3.87706 4 3.76151 3.97826 3.65365 3.93478C3.5458 3.8913 3.44565 3.82609 3.35321 3.73913Z"
        fill="currentColor"
      />
    </svg>
  );
}
